import React, { type FC } from "react";

import { isNumber } from "~/tools/is-number";

import { LoadingSpinner } from "../../loading-spinner/LoadingSpinner";
import { type ChartSize, getChartSize } from "../_utils";

export interface LoadingChartProps {
	size?: number | ChartSize;
}

export const LoadingChart: FC<LoadingChartProps> = ({ size }) => (
	<div
		className="relative z-10 mx-auto my-0 flex h-full w-full flex-col items-center justify-center"
		data-testid="loading-chart"
		style={{
			minHeight: isNumber(size) ? size : getChartSize(size),
		}}
	>
		<LoadingSpinner />
	</div>
);
